import { createAction, props } from '@ngrx/store'

export const showSideBar = createAction(
    '[Dashboard Page] Show Side Bar',
    props<{ error: string }>()
)